import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageMeta = ({ title, description, image }) => {
  const location = useLocation();
  const defaultImage = "https://res.cloudinary.com/digw3ykex/image/upload/f_auto,q_auto/v1767262722/LIVING_MEDIA_LOGO_TRANSPARENT_lvtpzg.png";
  const siteUrl = "https://livingmedia.digital";
  const currentUrl = `${siteUrl}${location.pathname === '/' ? '' : location.pathname}`;

  useEffect(() => {
    // Helper to update or create meta tags
    const updateMeta = (selector, attribute, value) => {
      let element = document.querySelector(selector);
      if (!element) {
        element = document.createElement('meta');
        
        // Determine if we need to set 'name' or 'property' based on the selector
        if (selector.includes('[property="')) {
          const property = selector.match(/property="([^"]+)"/)[1];
          element.setAttribute('property', property);
        } else if (selector.includes('[name="')) {
          const name = selector.match(/name="([^"]+)"/)[1];
          element.setAttribute('name', name);
        }
        
        document.head.appendChild(element);
      }
      element.setAttribute(attribute, value);
    };

    // 1. Basic SEO
    document.title = title;
    updateMeta('meta[name="description"]', 'content', description);

    // 2. Open Graph (Facebook, LinkedIn, Discord)
    updateMeta('meta[property="og:type"]', 'content', 'website');
    updateMeta('meta[property="og:url"]', 'content', currentUrl);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:image"]', 'content', image || defaultImage);

    // 3. Twitter Card
    updateMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    updateMeta('meta[name="twitter:url"]', 'content', currentUrl);
    updateMeta('meta[name="twitter:title"]', 'content', title);
    updateMeta('meta[name="twitter:description"]', 'content', description);
    updateMeta('meta[name="twitter:image"]', 'content', image || defaultImage);

  }, [title, description, image, currentUrl]);

  return null;
};

export default PageMeta;